export default [
  {
    path: "/usuario/dados-pessoais",
    name: "user-personal-data",
    component: () => import("../views/user/PersonalData.vue"),
    meta: {
      template: () => import("../templates/Base.vue"),
      protected: true,
      viewContainer: true,
      breadcrumbs: ["user-personal-data"]
    }
  },
  {
    path: "/usuario/dados-financeiros",
    name: "user-financial-data",
    component: () => import("../views/user/FinancialData.vue"),
    meta: {
      template: () => import("../templates/Base.vue"),
      protected: true,
      viewContainer: true,
      breadcrumbs: ["user-financial-data"]
    }
  },
  {
    path: "/usuario/adicionar-conta-bancaria",
    name: "new-bank-account",
    component: () => import("../views/user/NewBankAccount.vue"),
    meta: {
      template: () => import("../templates/Base.vue"),
      protected: true,
      viewContainer: true,
      breadcrumbs: ["user-financial-data", "new-bank-account"]
    }
  }
];
